import { jsx as m } from "react/jsx-runtime";
import { createIcon as d } from "@chakra-ui/react";
import { Icons as i } from "./types.js";
import { ThemeIconSizeVariable as p } from "../../theme/theme-types.js";
function f(e, o) {
  return Object.keys(i).find((n) => o[n] === e) ?? "";
}
const I = ({ icon: e, size: o = p.Medium, ...n }) => {
  const r = f(e, i), t = {
    width: o,
    height: o
  };
  r === "Caspeco" && (t.fillRule = "evenodd", t.clipRule = "evenodd");
  const c = d({
    displayName: r,
    viewBox: "0 0 20 20",
    d: e,
    defaultProps: t
  });
  return /* @__PURE__ */ m(c, { ...n });
};
export {
  I as Icon
};
